/** Maps API plan identifiers / Russian DB labels → i18n keys. */
export const PLAN_NAME_KEYS = {
    solo: 'billing:plans.solo',
    Соло: 'billing:plans.solo',
    club: 'billing:plans.club',
    Клуб: 'billing:plans.club',
    academy: 'billing:plans.academy',
    Академия: 'billing:plans.academy',
    federation: 'billing:plans.federation',
    Федерация: 'billing:plans.federation',
    corporation: 'billing:plans.corporation',
    Корпорация: 'billing:plans.corporation',
};

export function getPlanDisplayName(plan, t) {
    if (!plan) return '';
    const candidates = [plan.name, plan.slug, plan.displayName];
    for (const value of candidates) {
        if (!value) continue;
        const key = PLAN_NAME_KEYS[value];
        if (key) return t(key);
    }
    return plan.displayName || plan.name || '';
}
